var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-delivery-info"},_vm._l((_vm.config),function(item){return _c('span',{key:item.key,staticClass:"pay-delivery-info-item"},[_c('span',{staticClass:"pay-delivery-check",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }